import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";

export const Route = createFileRoute("/admin/_layout/documents")({
  beforeLoad: () => requireFeature("documents"),
  component: Outlet,
});
